import * as Dialog from "@radix-ui/react-dialog";

import { Button } from "~/shared";
import { icons } from "~/ui";
import { tw } from "~/utils";

type LeaveConfirmationModalProps = {
  show: boolean;
  onClose: () => void;
  onLeave: () => void;
};

export const LeaveConfirmationModal = ({
  show,
  onClose,
  onLeave,
}: LeaveConfirmationModalProps) => (
  <Dialog.Root open={show} onOpenChange={onClose}>
    <Dialog.Portal>
      <Dialog.Overlay className="fixed inset-0 z-50 bg-black/50 backdrop-blur-sm data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0" />
      <Dialog.Content
        className={tw(
          "fixed left-[50%] top-[20%] z-50 w-80 max-w-md translate-x-[-50%] translate-y-[-50%] rounded-xl bg-white p-4 shadow-lg duration-200 data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95",
        )}
      >
        <Dialog.Close
          asChild
          className="flex w-full justify-end outline-0 ring-0"
        >
          <button
            className="flex-shrink-0 text-gray-900 transition-colors hover:text-gray-600"
            aria-label="Close"
          >
            <icons.outline.XMarkIcon className="h-6 w-6" />
          </button>
        </Dialog.Close>
        <div className="mb-4 flex items-center justify-center">
          <div className="flex-1 text-center">
            <Dialog.Title className="font-medium text-gray-900">
              Are you sure you want to leave?
            </Dialog.Title>
            <Dialog.Description className="text-sm leading-relaxed text-gray-600">
              Your appointment slot and any entered information will be lost.
            </Dialog.Description>
          </div>
        </div>

        <div className="flex justify-center gap-2">
          <Dialog.Close asChild>
            <Button
              variant="outline"
              size="sm"
              onClick={onLeave}
              className="w-20"
            >
              Leave
            </Button>
          </Dialog.Close>

          <Button size="sm" onClick={onClose} className="w-20">
            Stay
          </Button>
        </div>
      </Dialog.Content>
    </Dialog.Portal>
  </Dialog.Root>
);
